import { render } from "./BedDropdown.vue?vue&type=template&id=40e23d40"
import script from "./BedDropdown.vue?vue&type=script&lang=js"
export * from "./BedDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__